export const PHONE_REGEXP = /^380\d{9}$/g;

export const TAX_ID_REGEXP = /^\d{10}$/;
export const DIGIT = /^\d+$/;
export const CYRILLIC_CHARACTERS = /[а-яА-ЯіІїЇєЄґҐэЭєЄыЫъЪЁё]/;

export const EMAIL_REGEXP =
	// eslint-disable-next-line max-len, no-useless-escape
	/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
